/*
 * Desktop - Side_cart - Secure Checkout  --  variant: Secure Checkout Icon Only
 * Moonshot experiment id: 42041251   status in Moonshot on 2026-08-27: DEPLOYED   started: 2025-08-27
 * Audience: DESKTOP   Target: side_cart   (see MGExp.targets in mg-exp-runtime.js)
 * Source: verbatim variant code from cdn.moonshot-ai.com/snippets/36780565.js (prettified);
 *         only change is window.msaiTools._msaiRunVariantBlock -> MGExp.runVariantBlock.
 * Enabled by theme setting: mgexp_sc_d_secure_checkout
 */
MGExp.run('sc_d_secure_checkout', { name: "Desktop - Side_cart - Secure Checkout / Secure Checkout Icon Only", platform: 'desktop', target: 'side_cart' }, function () {
  !(function () {
    let t = [],
      e = [];
    !(async function (i, c, a, s, o) {
      let n = {
        multi_target_selectors: t,
        page_identifier_selector: "#mini-cart-modal",
        exclude_from_timeout: e,
        selector_timeout: 5e3,
      };
      await MGExp.runVariantBlock(i, c, a, s, o, n);
    })(
      [".bag-checkout"],
      ".msai-secure-checkout-added",
      function (t, e) {
        const [i] = e;
        (i.insertAdjacentHTML(
          "afterbegin",
          '<svg class="msai-secure-checkout-icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#FFFFFF"><path d="M229-57q-38.78 0-66.39-27.61T135-151v-416q0-39.19 27.61-67.09Q190.22-662 229-662h50v-74q0-85.19 58.37-144.59Q395.73-940 479.87-940q84.13 0 142.63 59.41Q681-821.19 681-736v74h50q39.19 0 67.09 27.91Q826-606.19 826-567v416q0 38.78-27.91 66.39Q770.19-57 731-57H229Zm0-94h502v-416H229v416Zm251.17-131q31.83 0 54.33-22.03T557-357q0-30-22.67-54.5t-54.5-24.5q-31.83 0-54.33 24.5t-22.5 55q0 30.5 22.67 52.5t54.5 22ZM373-662h214v-73.77q0-46.73-30.65-77.98-30.64-31.25-76-31.25Q435-845 404-813.75q-31 31.25-31 77.98V-662ZM229-151v-416 416Z"/></svg>',
        ),
          i.classList.add("msai-secure-checkout-added"));
      },
      ".msai-secure-checkout-added{display:flex !important;align-items:center !important;justify-content:center !important;gap:6px !important}.msai-secure-checkout-icon{padding-bottom:3px}",
    );
  })();
});
